export enum GuardrailConfigurationEvent {
    // List page (AI Trust Layer > Guardrails) — fires once per tenant selection after first data load settles.
    ListViewed = 'GuardrailConfiguration.ListViewed',

    // List page interactions. Enabled/Disabled fire only when the toggle succeeds.
    CreateStarted = 'GuardrailConfiguration.CreateStarted',
    EditStarted = 'GuardrailConfiguration.EditStarted',
    StatusChecked = 'GuardrailConfiguration.StatusChecked',
    Enabled = 'GuardrailConfiguration.Enabled',
    Disabled = 'GuardrailConfiguration.Disabled',
    Deleted = 'GuardrailConfiguration.Deleted',

    // Add/Edit form.
    ConnectionTested = 'GuardrailConfiguration.ConnectionTested',
    Created = 'GuardrailConfiguration.Created',
    Updated = 'GuardrailConfiguration.Updated',
    FormCancelled = 'GuardrailConfiguration.FormCancelled',

    // Inline connector creation (opens Connector Builder in a new tab).
    ConnectorCreateDialogOpened = 'GuardrailConfiguration.ConnectorCreateDialogOpened',
    ConnectorCreateStarted = 'GuardrailConfiguration.ConnectorCreateStarted',
}
